import { Store } from 'src/store/index';

const getUpsellPriceData = (store: Store) => store.upsell.upsellPriceData;
export default getUpsellPriceData;
